import { Injectable } from '@angular/core';
import { UTM, UTM_MODEL_KEYS } from '@shared/interfaces/utm';
import { isInvalidValue } from '@shared/utils/utils';
import { IUtmsResource } from './utms.types';
import { StorageStrategyResource } from '@infra/storage';
import { StorageAdapter } from '@infra/storage/storage-adapter';
import { QueryParamsResource } from '@infra/query-params';

@Injectable({
  providedIn: 'root',
})
export class UtmsResource implements IUtmsResource {
  private cookiesStorage: StorageAdapter;

  constructor(
    private queryParamsResource: QueryParamsResource,
    storageStrategyResource: StorageStrategyResource,
  ) {
    this.cookiesStorage = storageStrategyResource.create('cookies');
  }

  getUtms(): UTM {
    this.retrieveUTMCookies();
    const utmCookies: UTM = this.cookiesStorage.getAll();

    const utm: UTM = UTM_MODEL_KEYS.reduce<UTM>((current, key) => {
      if (key === 'application') {
        // prettier-ignore
        const application = utmCookies.utm_source == 'mobile-app' || utmCookies.utm_source == 'anota-app-mobile-new' ? 'BOT_MOBILE' : utmCookies.application;
        return { ...current, application };
      }

      return { ...current, [key]: utmCookies[key] };
    }, {});

    const arUtm = Object.keys(utm) as Array<keyof UTM>;
    arUtm.forEach(key => {
      const value = utm[key];

      if (typeof value === 'string' && value.includes(',')) {
        utm[key] = value.slice(0, value.indexOf(','));
      }
    });

    arUtm.forEach(key => {
      if (isInvalidValue(utm[key])) {
        delete utm[key];
      }
    });

    return utm;
  }

  private retrieveUTMCookies(): void {
    const utms: UTM = this.queryParamsResource.getCurrent();
    const utmCookies = this.cookiesStorage.getAll<UTM>() || {};

    const data: UTM = UTM_MODEL_KEYS.reduce<UTM>(
      (current, key) => ({ ...current, [key]: utms[key] || utmCookies[key] }),
      {},
    );

    this.cookiesStorage.setAll(data);

    const hourInMilliseconds = 60 * 60 * 1000;
    const cookieValue = data.application ?? '';
    const expirationDate = new Date(new Date().getTime() + hourInMilliseconds);

    this.cookiesStorage.setItem('application', cookieValue, expirationDate);
  }
}
